import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { Test } from 'src/app/models/test.model';
import { Store, select } from '@ngrx/store';
import { fromTest } from 'src/app/reducers/test.reducer';

@Component({
  selector: 'ct-adn-examples',
  templateUrl: './adn-examples.component.html',
  styleUrls: ['./adn-examples.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdnExamplesComponent implements OnInit {

  @Input() colors: any;
  @ViewChild('adnExamplesModal') adnExamplesModal;

  modalRef: NgbModalRef;
  closeResult: string;
  examplesPageNumber: number;
  public test$: Observable<Test>;

  public currentTest: Test;


  // animaciones
  public IPExamplesAnimation0: object;
  public IPExamplesAnimation0Responsive: object;
  public IPExamplesAnimation1: object;
  public IPExamplesAnimation1Responsive: object;
  public IPExamplesAnimation2: object;
  public IPExamplesAnimation2Responsive: object;

  public NRExamplesAnimation0: object;
  public NRExamplesAnimation0Responsive: object;
  public NRExamplesAnimation1: object;
  public NRExamplesAnimation1Responsive: object;
  public NRExamplesAnimation2: object;
  public NRExamplesAnimation2Responsive: object;
  public NRExamplesAnimation3: object;
  public NRExamplesAnimation3Responsive: object;
  public NRExamplesAnimation4: object;
  public NRExamplesAnimation4Responsive: object;

  constructor(
    public modal: NgbModal,
    private store: Store,
  ) {
    // damos valor a las animaciones
    this.IPExamplesAnimation0 = { path: 'assets/animations/adn/examples/desktop-ipsativa-externos.json' };
    this.IPExamplesAnimation0Responsive = { path: 'assets/animations/adn/examples/mobile-ipsativa-externos.json' };
    this.IPExamplesAnimation1 = { path: 'assets/animations/adn/examples/desktop-ipsativa-medios.json' };
    this.IPExamplesAnimation1Responsive = { path: 'assets/animations/adn/examples/mobile-ipsativa-medios.json' };
    this.IPExamplesAnimation2 = { path: 'assets/animations/adn/examples/desktop-ipsativa-internos.json' };
    this.IPExamplesAnimation2Responsive = { path: 'assets/animations/adn/examples/mobile-ipsativa-internos.json' };

    this.NRExamplesAnimation0 = { path: 'assets/animations/adn/examples/desktop-normativa-menos_menos.json'};
    this.NRExamplesAnimation0Responsive = { path: 'assets/animations/adn/examples/mobile-normativa-menos_menos.json'};
    this.NRExamplesAnimation1 = { path: 'assets/animations/adn/examples/desktop-normativa-menos.json'};
    this.NRExamplesAnimation1Responsive = { path: 'assets/animations/adn/examples/mobile-normativa-menos.json'};
    this.NRExamplesAnimation2 = { path: 'assets/animations/adn/examples/desktop-normativa-igual.json'};
    this.NRExamplesAnimation2Responsive = { path: 'assets/animations/adn/examples/mobile-normativa-igual.json'};
    this.NRExamplesAnimation3 = { path: 'assets/animations/adn/examples/desktop-normativa-mas.json'};
    this.NRExamplesAnimation3Responsive = { path: 'assets/animations/adn/examples/mobile-normativa-mas.json'};
    this.NRExamplesAnimation4 = { path: 'assets/animations/adn/examples/desktop-normativa-mas_mas.json'};
    this.NRExamplesAnimation4Responsive = { path: 'assets/animations/adn/examples/mobile-normativa-mas_mas.json'};
  }
  
  ngOnInit(): void {
    this.test$ = this.store.pipe(select(fromTest.selectTestState));

    this.test$.subscribe(test => {
      this.currentTest = test;
    });

  }

  openModal() {
    this.examplesPageNumber = 0;
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.adnExamplesModal, { ariaLabelledBy: 'adnExamples', size: 'xl', backdrop: 'static', centered: false });
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      });
    }
  }

  closeModal() {
    this.modalRef.close();
  }

  public nextExamplesPage() {

    if ((this.currentTest.testModelId == 1 && this.examplesPageNumber < 4) || (this.currentTest.testModelId == 2 && this.examplesPageNumber < 2)) {
      this.examplesPageNumber++;
    } else {
      this.closeModal();
    }
  }

  public previousExamplesPage() {
    this.examplesPageNumber--;
  }
}
